import { render } from "./PrivacyStep.vue?vue&type=template&id=43704389&scoped=true&ts=true"
import script from "./PrivacyStep.vue?vue&type=script&lang=ts"
export * from "./PrivacyStep.vue?vue&type=script&lang=ts"

import "./PrivacyStep.vue?vue&type=style&index=0&id=43704389&lang=scss&scoped=true"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43704389"]])

export default __exports__